const Student = {

    // FIELDS
    "session_id": "Session",
    "course_id": "Course",
    "semester_id": "Semester",
    "student_fname": "First Name",
    "student_lname": "Last Name",
    "father_name": "Father Name",
    "roll_number": "Roll Number",
    "gender": "Gender",
    "email": "Email",
    "phone": "Phone Number",
    "dob": "Date of Birth",
    "search": "Search",

    // PAGE HEADER
    "student": "Student",

    // ERROR
    "error_session": "Select Session",
    "error_course": "Select Course",
    "error_semester": "Select Semester",
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_father": "Enter Father Name",
    "error_roll": "Enter Roll Number",
    "error_gender": "Select Gender",
    "error_email": "Enter Email",
    "error_valid_email": "Enter valid Email address",
    "error_phone": "Enter Phone Number",
    "error_dob": "Enter Date of Birth",

    // TABLE HEADER
    "table_session": "SESSION",
    "table_course": "COURSE",
    "table_semester": "SEMESTER",
    "table_fname": "FIRST NAME",
    "table_lname": "LAST NAME",
    "table_father": "FATHER NAME",
    "table_roll": "ROLL NUMBER",
    "table_gender": "GENDER",
    "table_email": "EMAIL",
    "table_phone": "PHONE NUMBER",
    "table_dob": "DATE OF BIRTH",

}

export default Student;
